// ============================================================
//  AWS CONFIGURATION — Fill in your values from the AWS Console
// ============================================================

const awsConfig = {
  Auth: {
    Cognito: {
      region: "us-east-1",
      userPoolId: "us-east-1_Y29Mjzv8u",
      userPoolClientId: "32blabmub1vaan57dj6ogvtmoc",
    }
  },
  API: {
    REST: {
      ConstructionExpenseAPI: {
        endpoint: "https://erugwnuz3l.execute-api.us-east-1.amazonaws.com/prod",
        region: "us-east-1"
      }
    }
  },
  Storage: {
    S3: {
      bucket: "40grit-construction-receipts",
      region: "us-east-1"
    }
  }
};

export default awsConfig;
